<template>
  <div class="toggle">
    <!-- <Transition name="fade" mode="out-in"> -->
    <span :lastKey="title" v-show="title" class="toggle__label">{{
      title
    }}</span>
    <!-- </Transition> -->
    <label class="toggle__element" :class="size">
      <input
        class="toggle__element__input"
        type="checkbox"
        :checked="valorSel"
        @change="$emit('valor', $event.target.checked)"
      />
      <span class="toggle__element__slider"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'Toggle',
  props: {
    title: {
      type: String,
      default: null,
    },
    valorSel: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    inactiveColor: {
      type: String,
      default: '#e5e5ea',
    },
    activeColor: {
      type: String,
      default: 'black',
    },
    knobColor: {
      type: String,
      default: '#ffffff',
    },
  },
};
</script>

<style scoped lang="scss">
.toggle {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  &__label {
    font-size: 14px;
    font-weight: inherit;
    margin-right: 15px;
  }
  &__element {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    &__input {
      display: none;
      &:checked {
        & + .toggle__element {
          &__slider {
            background-color: v-bind(activeColor);
            -webkit-transition: 0.35s ease-in-out background-color;
            -moz-transition: 0.35s ease-in-out background-color;
            -ms-transition: 0.35s ease-in-out background-color;
            -o-transition: 0.35s ease-in-out background-color;
            transition: 0.35s ease-in-out background-color;
            &:before {
              transform: translateX(20px);
              -webkit-transition: 0.35s ease-in-out transform;
              -moz-transition: 0.35s ease-in-out transform;
              -ms-transition: 0.35s ease-in-out transform;
              -o-transition: 0.35s ease-in-out transform;
              transition: 0.35s ease-in-out transform;
            }
          }
        }
      }
    }
    &__slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 16px;
      background-color: v-bind(inactiveColor);
      -webkit-transition: 0.35s ease-in-out background-color;
      -moz-transition: 0.35s ease-in-out background-color;
      -ms-transition: 0.35s ease-in-out background-color;
      -o-transition: 0.35s ease-in-out background-color;
      transition: 0.35s ease-in-out background-color;
      &:before {
        content: '';
        position: absolute;
        height: 16px;
        width: 16px;
        left: 2px;
        top: 2px;
        background-color: v-bind(knobColor);
        border-radius: 50%;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        -webkit-transition: 0.35s ease-in-out transform;
        -moz-transition: 0.35s ease-in-out transform;
        -ms-transition: 0.35s ease-in-out transform;
        -o-transition: 0.35s ease-in-out transform;
        transition: 0.35s ease-in-out transform;
      }
    }
    &.sm {
      width: 30px;
      height: 16px;
      & .toggle__element {
        &__input {
          &:checked {
            & + .toggle__element {
              &__slider {
                &:before {
                  transform: translateX(14px);
                  -webkit-transition: 0.35s ease-in-out transform;
                  -moz-transition: 0.35s ease-in-out transform;
                  -ms-transition: 0.35s ease-in-out transform;
                  -o-transition: 0.35s ease-in-out transform;
                  transition: 0.35s ease-in-out transform;
                }
              }
            }
          }
        }
        &__slider {
          border-radius: 12px;
          &:before {
            height: 12px;
            width: 12px;
            left: 2px;
            top: 2px;
            transform: translateX(0);
            -webkit-transition: 0.35s ease-in-out transform;
            -moz-transition: 0.35s ease-in-out transform;
            -ms-transition: 0.35s ease-in-out transform;
            -o-transition: 0.35s ease-in-out transform;
            transition: 0.35s ease-in-out transform;
          }
        }
      }
    }
    &.lg {
      width: 60px;
      height: 28px;
      & .toggle__element {
        &__input {
          &:checked {
            & + .toggle__element {
              &__slider {
                &:before {
                  transform: translateX(32px);
                  -webkit-transition: 0.35s ease-in-out transform;
                  -moz-transition: 0.35s ease-in-out transform;
                  -ms-transition: 0.35s ease-in-out transform;
                  -o-transition: 0.35s ease-in-out transform;
                  transition: 0.35s ease-in-out transform;
                }
              }
            }
          }
        }
        &__slider {
          border-radius: 20px;
          &:before {
            height: 24px;
            width: 24px;
            left: 2px;
            top: 2px;
            transform: translateX(0);
            -webkit-transition: 0.35s ease-in-out transform;
            -moz-transition: 0.35s ease-in-out transform;
            -ms-transition: 0.35s ease-in-out transform;
            -o-transition: 0.35s ease-in-out transform;
            transition: 0.35s ease-in-out transform;
          }
        }
      }
    }
  }
}
</style>
